import {
  ApiResponse,
  Campaign,
  CampaignDetail,
  CampaignDiscount,
  CampaignGrouped,
  CloneCampaign,
  ConnectedCampaign,
  CreateCampaignDiscount,
  EditCampaignDiscount,
  OtpResponse,
} from '../models';
import { EcomCampaign } from '../models/ecom/campaign';
import {
  SalesTarget,
  SalesTargetData,
  SalesTargetDataFiles,
  SalesTargetGrouped,
} from '../models/salesTarget';
import * as http from './http';
import ApiService from './service';

export class SalesTargetService extends ApiService {
  public async createSalesTarget(data: SalesTarget) {
    const url = `${this.apiDomain}/api/sales-target/create`;

    const response = await http.post<SalesTarget>(url, data, this.store);
    return response.data;
  }

  public async loadSalesTarget() {
    const url = `${this.apiDomain}/api/sales-target/targets`;

    const resposne = await http.get<ApiResponse<SalesTarget[]>>(
      url,
      this.store
    );
    return resposne?.data;
  }

  public async getSalesTargetDetails(id: string): Promise<SalesTargetData> {
    const url = `${this.apiDomain}/api/sales-target/${id}`;

    const resposne = await http.get<SalesTargetData>(url, this.store);
    return resposne?.data;
  }

  public async updateSalesTargetBasic(
    id: string,
    targetDate: Date,
    title?: string
  ) {
    const url = `${this.apiDomain}/api/sales-target/${id}`;

    const resposne = await http.put<SalesTarget>(
      url,
      {
        title,
        targetDate,
      },
      this.store
    );
    return resposne?.data;
  }

  public async updateSalesTarget(
    id: string,
    targetData: SalesTargetDataFiles[]
  ) {
    const url = `${this.apiDomain}/api/sales-target/${id}/target`;

    const resposne = await http.put<SalesTarget>(
      url,
      {
        targetData,
      },
      this.store
    );
    return resposne?.data;
  }

  public async bulkUpdateSalesTarget(
    id: string,
    targetData?: SalesTargetDataFiles[]
  ) {
    const url = `${this.apiDomain}/api/sales-target/${id}/target`;

    const resposne = await http.put<SalesTarget>(
      url,
      {
        targetData,
      },
      this.store
    );
    return resposne?.data;
  }

  public async downloadSalesTarget(id: string) {
    const url = `${this.apiDomain}/api/sales-target/${id}/download`;
    const reponse = await http.download(url, this.store);
    http.saveDownloadedFile(
      reponse.data,
      'application/pdf',
      `${'SalesTarget'}.xlsx`
    );
    return;
  }
}
